// MM 모바일 날짜 floating 배지를 '최신 글 날짜'로 보정 (req-20260928-111009-70f4ed).
// 🔴 배지 안 <time> 은 MM(React) 소유 → textContent 를 안 쓰고 표식 + 주입 CSS(::after)로만 라벨을 덧그린다
//    (표식만 지우면 MM 원문이 그대로 다시 보인다 = 복원에 텍스트 쓰기 불필요).
// 🔴 게이트 해제는 사용자 제스처(wheel·touchmove·스크롤키)만 — MM 이 일으키는 프로그램 scroll 은 아니다.
// 🔴 변이는 즉시 반영, scroll·제스처는 rAF 로 프레임당 1회(강제 레이아웃 최소화).
// 🔴 MM API 는 GET·20건·15초 스로틀 + 채널 epoch 가드(남의 운영 시스템 보호).
export const BADGE_SEL = '[data-testid="floatingTimestamp"]';
export const POST_SEL = '[data-testid="postView"]';
export const LIST_SEL = '.post-list__dynamic';
export const MOBILE_MAX_WIDTH = 768;
export const BOTTOM_TOLERANCE_PX = 40;
export const API_TTL_MS = 15000;   // API 진실원 스로틀 겸 그 값의 신선도 창
export const API_PER_PAGE = 20;
export const SCAN_TTL_MS = 200;    // 전수 재스캔 보험 상한
export const MARK_ATTR = 'data-gw-floating-date';
export const STYLE_ID = 'gw-mm-floating-date-css';
export const SCROLL_KEYS = ['PageUp', 'PageDown', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
export const HIDE_RULE_SEL = BADGE_SEL + ' [' + MARK_ATTR + '] > time';
export const LABEL_RULE_SEL = BADGE_SEL + ' [' + MARK_ATTR + ']';
// 🔴 전 규칙을 @media (max-width:768px) 안에 둔다 — 데스크톱 회귀 0.
export const FLOATING_DATE_CSS = '@media (max-width:768px){'
  + HIDE_RULE_SEL + '{display:none !important}'
  + LABEL_RULE_SEL + '::after{content:attr(' + MARK_ATTR + ')}}';

// head 에 style 1개만 유지(폴링 + onLoad 이중 호출 → 멱등).
export function ensureFloatingDateCss(doc) {
  if (!doc || !doc.head) return null;
  try {
    const found = doc.getElementById(STYLE_ID);
    if (found) { if (found.textContent !== FLOATING_DATE_CSS) found.textContent = FLOATING_DATE_CSS; return found; }
    const st = doc.createElement('style');
    st.id = STYLE_ID;
    st.textContent = FLOATING_DATE_CSS;
    doc.head.appendChild(st);
    return st;
  } catch (e) { return null; }
}

const DAY_MS = 86400000;

function dayStart(ms) { const d = new Date(ms); d.setHours(0, 0, 0, 0); return d.getTime(); }

function parseStamp(raw) {
  if (raw === null || raw === undefined) return null;
  const s = String(raw).trim();
  if (!s) return null;
  if (/^\d{10,}$/.test(s)) { const n = Number(s); return Number.isFinite(n) ? (s.length <= 10 ? n * 1000 : n) : null; }
  const t = Date.parse(s);
  return Number.isFinite(t) ? t : null;
}

export function createState() {
  return { path: null, userScrolled: false, latestMs: null, apiAt: 0, domMs: null, domAt: 0,
    scanDirty: true, bottom: null, bottomDirty: true, channelId: null, apiBusy: false, apiFails: 0,
    apiOff: false, applied: null, badgeEl: null };
}

export function isMobileView(doc) {   // 폭을 못 재면 false(데스크톱 무회귀 우선)
  if (!doc) return false;
  try {
    const iw = doc.defaultView && doc.defaultView.innerWidth;
    if (typeof iw === 'number' && iw > 0) return iw <= MOBILE_MAX_WIDTH;
    const cw = doc.documentElement && doc.documentElement.clientWidth;
    if (typeof cw === 'number' && cw > 0) return cw <= MOBILE_MAX_WIDTH;
  } catch (e) { /* */ }
  return false;
}

export function postTimeMs(el) {
  if (!el || typeof el.querySelector !== 'function') return null;
  try {
    const cands = [['time[datetime]', 'datetime'], ['[data-timestamp]', 'data-timestamp'], ['time[title]', 'title']];
    for (let i = 0; i < cands.length; i += 1) {
      const node = el.querySelector(cands[i][0]);
      const ms = node ? parseStamp(node.getAttribute(cands[i][1])) : null;
      if (ms !== null) return ms;
    }
  } catch (e) { /* */ }
  return null;
}

// 🔴 'DOM 의 마지막 글' 가정 금지 — MM 가상 목록의 순서는 실측 못 했다. 최댓값은 순서 가정이 필요 없다.
export function latestRenderedPostMs(doc) {
  if (!doc || typeof doc.querySelectorAll !== 'function') return null;
  let best = null;
  try {
    doc.querySelectorAll(POST_SEL).forEach((el) => {
      if (el.classList && el.classList.contains('post--system')) return;
      const ms = postTimeMs(el);
      if (ms !== null && (best === null || ms > best)) best = ms;
    });
  } catch (e) { /* */ }
  return best;
}

export function firstPostId(doc) {
  if (!doc || typeof doc.querySelectorAll !== 'function') return null;
  let found = null;
  try {
    doc.querySelectorAll(POST_SEL).forEach((el) => {
      if (found || (el.classList && el.classList.contains('post--system'))) return;
      const id = (el.id || '').replace(/^post_/, '');
      if (id) found = id;
    });
  } catch (e) { /* */ }
  return found;
}

// 오늘·어제는 그대로, 그보다 이전 날짜는 연도를 떼고 'MM월 DD일'(월·일 두 자리, 예 09월 28일).
// 🔴 ko-KR toLocaleDateString 에는 '월/일' 접미사 + 두 자리 조합이 없다(2-digit 은 '09. 28.') → 직접 조립.
// 기준 시각은 로컬(브라우저) 타임존 — dayStart 와 같다(서버시간·UTC 보정 코드를 새로 만들지 않는다).
export function formatDateLabel(ms, nowMs) {
  if (!Number.isFinite(ms)) return null;
  const diff = Math.round((dayStart(Number.isFinite(nowMs) ? nowMs : Date.now()) - dayStart(ms)) / DAY_MS);
  if (diff === 0) return '오늘';
  if (diff === 1) return '어제';
  try {
    const d = new Date(ms);
    const pad = (n) => (n < 10 ? '0' + n : String(n));
    return pad(d.getMonth() + 1) + '월 ' + pad(d.getDate()) + '일';
  } catch (e) { return null; }
}

export function isAtBottom(doc) {
  if (!doc || typeof doc.querySelector !== 'function') return null;
  let el = null;
  try {
    el = doc.querySelector(LIST_SEL);
    for (let i = 0; i < 4 && el; i += 1) {
      if (el.clientHeight > 0 && el.scrollHeight > el.clientHeight) break;
      if (!el.parentElement) break;
      el = el.parentElement;
    }
  } catch (e) { return null; }
  if (!el) return null;
  const sh = el.scrollHeight; const st = el.scrollTop; const ch = el.clientHeight;
  if (!Number.isFinite(sh) || !Number.isFinite(st) || !Number.isFinite(ch)) return null;
  if (sh <= 0 || ch <= 0) return null;   // 레이아웃 미계산(jsdom·로드 중) = 판정 불가
  return (sh - st - ch) <= BOTTOM_TOLERANCE_PX;
}

// 🔴 강제 레이아웃(scrollHeight/scrollTop/clientHeight)은 스크롤·글 변화 때만 — 그 사이엔 캐시.
export function isAtBottomCached(doc, state) {
  if (!state) return isAtBottom(doc);
  if (state.bottomDirty) { state.bottom = isAtBottom(doc); state.bottomDirty = false; }
  return state.bottom;
}

// 라벨 자리 = 배지 안 <time> 의 부모(MM 실측: 배지 > span > time). <time> 자체는 안 건드린다.
export function labelTarget(badge) {
  if (!badge || typeof badge.querySelector !== 'function') return null;
  try {
    const t = badge.querySelector('time');
    return (t && t.parentElement && t.parentElement !== badge) ? t.parentElement : null;
  } catch (e) { return null; }
}

// 사용자가 '직접' 스크롤했는가 — MM 이 일으키는 프로그램 scroll 은 여기 안 들어온다.
export function isUserScrollEvent(ev) {
  if (!ev) return false;
  if (ev.type === 'wheel' || ev.type === 'touchmove') return true;
  return ev.type === 'keydown' && SCROLL_KEYS.indexOf(ev.key) >= 0;
}

// 🔴 글이 드나든 변이만 전수 재스캔을 부른다 — MM 은 타이핑 표시 등으로 프레임마다 변이를 낸다.
export function mutationsTouchPosts(records) {
  if (!records || !records.length) return false;
  const hit = (n) => {
    try { return !!n && n.nodeType === 1 && ((n.matches && n.matches(POST_SEL)) || (n.querySelector && n.querySelector(POST_SEL))); } catch (e) { return false; }
  };
  for (let i = 0; i < records.length; i += 1) {
    const r = records[i];
    if (!r || r.type !== 'childList') continue;
    const nodes = [].concat(Array.prototype.slice.call(r.addedNodes || []), Array.prototype.slice.call(r.removedNodes || []));
    if (nodes.some(hit)) return true;
    try { const t = r.target; if (t && t.nodeType === 1 && t.closest && t.closest(POST_SEL)) return true; } catch (e) { /* */ }
  }
  return false;
}

export function shouldOverride(doc, state) {
  if (!doc || !state || typeof doc.querySelector !== 'function') return false;
  let badge = null;
  try { badge = doc.querySelector(BADGE_SEL); } catch (e) { return false; }
  if (!badge || !isMobileView(doc)) return false;
  if (!state.userScrolled) return true;              // 진입 직후 — MM 이 어디로 스크롤했든 최신 날짜
  return isAtBottomCached(doc, state) === true;      // 사용자가 올려본 뒤에는 맨 아래에서만
}

// 게이트가 풀리면 표식만 지운다 — MM 의 <time> 이 그대로 다시 보인다.
export function restore(badge, state) {
  let did = false;
  if (state && state.applied !== null && state.applied !== undefined) { state.applied = null; did = true; }
  if (!badge) return did;
  try {
    if (badge.hasAttribute(MARK_ATTR)) { badge.removeAttribute(MARK_ATTR); did = true; }
    badge.querySelectorAll('[' + MARK_ATTR + ']').forEach((el) => { el.removeAttribute(MARK_ATTR); did = true; });
  } catch (e) { /* */ }
  return did;
}

// 최신 시각 = max(신선한 API 진실원, 렌더된 글 최댓값). 🔴 API 값도 API_TTL_MS 안에서만 쓴다
// (최신 글이 지워지면 옛 값이 남는다). 전수 스캔은 scanDirty 거나 캐시가 SCAN_TTL_MS 를 넘겼을 때만.
export function latestKnownMs(doc, state, nowMs) {
  const now = Number.isFinite(nowMs) ? nowMs : Date.now();
  const fresh = Number.isFinite(state.latestMs) && state.apiAt > 0 && (now - state.apiAt) < API_TTL_MS;
  const api = fresh ? state.latestMs : null;
  const stale = state.scanDirty || !Number.isFinite(state.domMs) || (now - state.domAt) >= SCAN_TTL_MS;
  let dom = stale ? null : state.domMs;
  if (stale) {
    dom = latestRenderedPostMs(doc);
    state.scanDirty = false;
    if (dom !== null) { state.domMs = dom; state.domAt = now; }
  }
  return (dom !== null && (api === null || dom > api)) ? dom : api;
}

// 반환 = 적용 라벨/null. 같은 상태 재호출은 DOM 무변경(멱등 = 옵저버 자가 트리거 방지).
export function applyLatestDate(doc, state, nowMs) {
  if (!doc || !state || typeof doc.querySelector !== 'function') return null;
  const now = Number.isFinite(nowMs) ? nowMs : Date.now();
  let path = null;
  try { path = (doc.location && doc.location.pathname) || null; } catch (e) { path = null; }
  if (path !== state.path) {   // 채널 이동 — 문서 단위(apiOff·apiBusy)만 남기고 그 방의 값은 버린다
    state.path = path; state.userScrolled = false; state.latestMs = null; state.apiAt = 0;
    state.domMs = null; state.domAt = 0; state.scanDirty = true; state.channelId = null;
    state.bottom = null; state.bottomDirty = true; state.apiFails = 0; state.applied = null; state.badgeEl = null;
  }
  let badge = null;
  try { badge = doc.querySelector(BADGE_SEL); } catch (e) { return null; }
  if (!badge) { state.applied = null; state.badgeEl = null; return null; }
  if (state.badgeEl !== badge) { state.badgeEl = badge; state.applied = null; }
  if (!shouldOverride(doc, state)) { restore(badge, state); return null; }
  const ms = latestKnownMs(doc, state, now);
  const label = ms === null ? null : formatDateLabel(ms, now);
  const target = label ? labelTarget(badge) : null;
  if (!target) { restore(badge, state); return null; }   // 🔴 옛 채널 라벨이 남으면 안 된다
  try {
    ensureFloatingDateCss(doc);
    if (badge.getAttribute(MARK_ATTR) !== label) badge.setAttribute(MARK_ATTR, label);
    if (target.getAttribute(MARK_ATTR) !== label) target.setAttribute(MARK_ATTR, label);
  } catch (e) { return null; }
  state.applied = label;
  return label;
}

export function latestApiPostMs(payload) {
  if (!payload) return null;
  const raw = Array.isArray(payload) ? payload : (payload.posts || null);
  if (!raw) return null;
  const list = Array.isArray(raw) ? raw : Object.keys(raw).map((k) => raw[k]);
  let best = null;
  list.forEach((p) => {
    if (!p || p.delete_at || String(p.type || '').indexOf('system_') === 0) return;
    const ms = Number(p.create_at);
    if (Number.isFinite(ms) && ms > 0 && (best === null || ms > best)) best = ms;
  });
  return best;
}

// 진실원(best-effort). 🔴 GET·20건·15초 스로틀·중복 방지·2연속 실패면 그 doc 에서 중단.
// 🔴 채널 epoch(=경로) 가드 — 비행 중 응답이 그 사이 옮겨 간 채널 상태로 새지 않게 버린다.
export function fetchLatestPostMs(doc, state, onDone) {
  if (!doc || !state || state.apiOff || state.apiBusy) return Promise.resolve(null);
  if (state.apiAt && (Date.now() - state.apiAt) < API_TTL_MS) return Promise.resolve(null);
  let fetchFn = null;
  try { const w = doc.defaultView; if (w && typeof w.fetch === 'function') fetchFn = w.fetch.bind(w); } catch (e) { fetchFn = null; }
  const postId = state.channelId ? null : firstPostId(doc);
  if (!fetchFn || (!state.channelId && !postId)) return Promise.resolve(null);
  const epoch = state.path;
  const stale = () => state.path !== epoch;
  const getJson = (url) => fetchFn(url, { credentials: 'include' }).then((r) => {
    if (!r || !r.ok) throw new Error('mm-http');
    return r.json();
  });
  state.apiBusy = true;
  return (state.channelId ? Promise.resolve(state.channelId)
    : getJson('/mm/api/v4/posts/' + encodeURIComponent(postId)).then((p) => (p && p.channel_id) || null))
    .then((cid) => {
      if (!cid || stale()) return null;
      state.channelId = cid;
      return getJson('/mm/api/v4/channels/' + encodeURIComponent(cid) + '/posts?per_page=' + API_PER_PAGE);
    })
    .then((payload) => {
      const ms = (payload && !stale()) ? latestApiPostMs(payload) : null;
      if (ms === null) return null;
      state.latestMs = ms;   // 🔴 채널 단위 대입(단조증가 금지) — 최신 글이 지워지면 내려가야 한다
      state.apiFails = 0;
      return ms;
    })
    .catch(() => { state.apiFails = (state.apiFails || 0) + 1; if (state.apiFails >= 2) state.apiOff = true; return null; })
    .then((ms) => {
      state.apiBusy = false;
      if (!stale()) state.apiAt = Date.now();   // 성공·빈 결과·실패를 같은 15초 창으로 묶는다
      if (ms !== null && typeof onDone === 'function') { try { onDone(ms); } catch (e) { /* */ } }
      return ms;
    });
}

// doc 당 1회 설치. 반환 = dispose(리스너·옵저버 정리 + 표식·주입 CSS 되돌리기). 이미 설치면 null.
export function setupMmFloatingDate(doc, options) {
  const isActive = (options && typeof options.isActive === 'function') ? options.isActive : () => true;
  if (!doc || !doc.body || doc.__gwFloatDate) return null;
  doc.__gwFloatDate = true;
  const state = createState();
  const win = doc.defaultView || null;
  let disposed = false;
  let frame = 0;
  const apply = () => {   // 🔴 디바운스 없음 — 배지는 잠깐만 보여 늦게 쓰면 옛 날짜가 먼저 보인다
    if (disposed || !isActive()) return;
    try { applyLatestDate(doc, state); } catch (e) { /* */ }
  };
  const kick = () => {
    apply();
    if (disposed || !isActive()) return;
    try { if (shouldOverride(doc, state)) fetchLatestPostMs(doc, state, apply); } catch (e) { /* */ }
  };
  const schedule = () => {   // 🔴 scroll·제스처는 프레임당 1회로 합친다
    if (disposed || frame) return;
    if (!win || typeof win.requestAnimationFrame !== 'function') { apply(); return; }
    frame = win.requestAnimationFrame(() => { frame = 0; apply(); });
  };
  kick();
  let obs = null;
  try {
    // 🔴 목록이 아니라 doc.body 에 건다(채널을 옮기면 목록 요소가 갈린다). attributes 는 미관찰.
    const MO = (win && win.MutationObserver) || (typeof window !== 'undefined' ? window.MutationObserver : null);
    if (MO) {
      obs = new MO((records) => {
        if (mutationsTouchPosts(records)) { state.scanDirty = true; state.bottomDirty = true; }
        kick();
      });
      obs.observe(doc.body, { childList: true, subtree: true, characterData: true });
    }
  } catch (e) { obs = null; }
  const onScroll = () => { if (disposed) return; state.bottomDirty = true; schedule(); };   // 프로그램 scroll 은 게이트를 안 푼다
  const onGesture = (ev) => {
    if (disposed) return;
    if (isUserScrollEvent(ev)) state.userScrolled = true;
    state.bottomDirty = true;
    schedule();
  };
  try {
    doc.addEventListener('scroll', onScroll, true);   // scroll 은 버블하지 않는다 → capture
    doc.addEventListener('wheel', onGesture, { capture: true, passive: true });
    doc.addEventListener('touchmove', onGesture, { capture: true, passive: true });
    doc.addEventListener('keydown', onGesture, true);
  } catch (e) { /* */ }
  return function dispose() {
    if (disposed) return;
    disposed = true;
    try { if (frame && win && typeof win.cancelAnimationFrame === 'function') win.cancelAnimationFrame(frame); } catch (e) { /* */ }
    frame = 0;
    try { if (obs) obs.disconnect(); } catch (e) { /* */ }
    try {
      doc.removeEventListener('scroll', onScroll, true);
      doc.removeEventListener('wheel', onGesture, true);
      doc.removeEventListener('touchmove', onGesture, true);
      doc.removeEventListener('keydown', onGesture, true);
    } catch (e) { /* */ }
    try { restore(doc.querySelector(BADGE_SEL), state); } catch (e) { /* */ }
    try { const st = doc.getElementById(STYLE_ID); if (st && st.parentNode) st.parentNode.removeChild(st); } catch (e) { /* */ }
    doc.__gwFloatDate = false;
  };
}
